// extracted by mini-css-extract-plugin
module.exports = {"card":"HomeApplication_card__2pSE8","disabledCard":"HomeApplication_disabledCard__3OBVV"};